import * as v from "valibot";

import { Member } from "@/features/members/member";

const searchSchema = v.object({
  view: v.optional(v.picklist(["check-ins", "guardmes", "incidents"] as const)),
});

export const Route = createFileRoute({
  component: Member,
  validateSearch: searchSchema,
});
